import { MetadataColumn } from '@bechtel/sr-types';
import { FieldHelperProps, FieldInputProps, FieldMetaProps } from 'formik';
import { FC, PropsWithChildren, createContext, useContext } from 'react';
import { FormFieldProps } from './types';

const FormFieldContextPrivate = createContext<FormFieldContextProps>({
  formFieldProps: { memberName: '' },
  valueChanged: false,
});

const { Provider } = FormFieldContextPrivate;

export const useFormFieldContext = () => {
  return useContext(FormFieldContextPrivate);
};

interface FormFieldContextProps {
  formFieldProps: FormFieldProps;
  formikFieldProps?: [FieldInputProps<any>, FieldMetaProps<any>, FieldHelperProps<any>];
  metadataColumn?: MetadataColumn;
  valueChanged: boolean;
  handleFocus?: (focus: boolean) => void;
  isChangeControl?: boolean;
  convertToUpperCase?: boolean;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export const FormFieldContext: FC<PropsWithChildren<FormFieldContextProps>> = ({
  children,
  ...formFieldContextProps
}) => {
  return <Provider value={formFieldContextProps}>{children}</Provider>;
};
